import Box from '@mui/material/Box';

const STOPWORDS = new Set(['a', 'an', 'and', 'are', 'as', 'at', 'for', 'in', 'is', 'of', 'on', 'or', 'the', 'to', 'what', 'ocbc', 'view']);

const escape = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/** The searched words, from the query the user typed. */
export function searchTerms(query: string): string[] {
  return [...new Set(query.toLowerCase().split(/[^a-z0-9]+/).filter((w) => w.length > 1 && !STOPWORDS.has(w)))];
}

/** Text with each searched word in bold, so the reader sees why a report matched. */
export function Highlighted({ text, terms }: { text: string; terms: string[] }) {
  if (terms.length === 0) return text;
  const pattern = new RegExp(`\\b(${terms.map(escape).join('|')})`, 'gi');
  return text.split(pattern).map((part, i) =>
    i % 2 === 1 ? (
      <Box component="mark" key={`m-${i}`} sx={{ bgcolor: 'transparent', color: 'inherit', fontWeight: 600 }}>
        {part}
      </Box>
    ) : (
      part
    ),
  );
}
